export enum EnumTimeToSendNotification {
  OfficeHours= 1,
  AfterHours
}

export namespace EnumTimeToSendNotification {
  export function values() {
    return Object.keys(EnumTimeToSendNotification).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
